import { Box } from 'components/Box/Box';
import { Text } from 'components/Text/Text';
import { useI18n } from 'i18n/hooks/useI18n';
import { colors } from 'theme/theme';

export function CharacterCounter({
  maxLength,
  currentCount,
}: {
  maxLength: number;
  currentCount: number;
}) {
  const { i18n } = useI18n();
  const charsLeft = maxLength - currentCount;
  return (
    <Box mt="5px" mb="20px" display="flex" justifyContent="flex-end">
      <Text
        styleAs="bodySmall"
        color={charsLeft === 0 ? colors.alertRed : colors.mediumContentGrey}
      >
        {charsLeft === 1
          ? i18n('%(count)s character left', { count: charsLeft })
          : i18n('%(count)s characters left', { count: charsLeft })}
      </Text>
    </Box>
  );
}
